import React from "react";
import classes from "./PageSummary.module.css";

const PersonalHubSummary = (props) => {
  return (
    <section className={classes.summary}>
      <h2 style={{ fontWeight: "bold" }}>
        Welcome {props.name + " "}to the @one Alliance Project Viewer Personal Hub
      </h2>
      <p>This Personal Hub page is for the Engineering Team</p>
    </section>
  );
};

export default PersonalHubSummary;
